import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createSlots as _createSlots, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-957b1c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-xl-10 mx-auto mb-10" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_5 = { class: "fw-bold d-flex align-items-center text-dark" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Reviewing   ")
const _hoisted_7 = { class: "text-primary" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("'s KYC ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-semobold fs-6" }, [
  /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://morrisonrecordsbureau.com/contact-us/",
    class: "link-primary fw-bold"
  }, "Help Page"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Validity Score", -1))
const _hoisted_12 = { class: "col-12 col-xl-10 mx-auto" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = { class: "card-header unset-height position-relative" }
const _hoisted_15 = ["data-bs-target"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Expired")
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-sm-12" }
const _hoisted_19 = { class: "nav" }
const _hoisted_20 = {
  class: "card-body",
  id: "data-kt-customer-payment-method"
}
const _hoisted_21 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_ReviewItemHeader = _resolveComponent("ReviewItemHeader")!
  const _component_PhotoMatch = _resolveComponent("PhotoMatch")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Notice = _resolveComponent("Notice")!
  const _component_OCRModal = _resolveComponent("OCRModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.kyc?.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.kyc?.user?.fullname), 1),
                    _hoisted_8
                  ]),
                  _hoisted_9
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_apexchart, {
                    class: "mixed-widget-4-chart",
                    options: _ctx.chartOptions,
                    series: [_ctx.percentageValidity],
                    height: 100,
                    width: 100,
                    type: "radialBar"
                  }, null, 8, ["options", "series"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "btn btn-link btn-sm position-absolute",
                style: {"right":"27px","top":"8px"},
                "data-bs-toggle": "modal",
                "data-bs-target": `#${_ctx.$modals.VIEW_OCR_MODAL}`
              }, " View OCR ", 8, _hoisted_15),
              (!_ctx.hasIdExpired)
                ? (_openBlock(), _createBlock(_component_Badge, {
                    key: 0,
                    class: "position-absolute",
                    style: {"right":"100px","top":"14px"},
                    variant: "danger",
                    light: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("ul", _hoisted_19, [
                    _createElementVNode("li", {
                      class: "nav-item",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = 1))
                    }, [
                      _createElementVNode("h6", {
                        class: _normalizeClass([_ctx.tab == 1 ? 'nav-link active' : 'nav-link', "h-100 mb-0"])
                      }, " KYC ", 2)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_ctx.tab == 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_Accordion, { id: "all" }, {
                      header: _withCtx(() => [
                        _createVNode(_component_ReviewItemHeader, { title: "Overview" })
                      ]),
                      hidden: _withCtx(() => [
                        _createVNode(_component_PhotoMatch, { form: _ctx.kyc }, null, 8, ["form"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Accordion, { id: "photo_verified" }, {
                      header: _withCtx(() => [
                        _createVNode(_component_ReviewItemHeader, {
                          title: "Photo Match Status",
                          status: 
                      _ctx.kyc.photo_verified || _ctx.kyc.status === _ctx.COMPLETED
                        ? 'Matched'
                        : 'Not matched'
                    ,
                          passed: _ctx.kyc.photo_verified || _ctx.kyc.status === _ctx.COMPLETED
                        }, null, 8, ["status", "passed"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Accordion, { id: "doc_type" }, _createSlots({
                      header: _withCtx(() => [
                        _createVNode(_component_ReviewItemHeader, {
                          title: "Document Type",
                          status: _ctx.getStatusMessage(_ctx.review.doc_type),
                          passed: _ctx.review.doc_type
                        }, null, 8, ["status", "passed"])
                      ]),
                      _: 2
                    }, [
                      (_ctx.review.desc_doc_type && !_ctx.review.doc_type)
                        ? {
                            name: "hidden",
                            fn: _withCtx(() => [
                              _createVNode(_component_Notice, {
                                classes: "rounded-3 mb-8",
                                color: "danger",
                                title: "Decline Reason",
                                icon: "media/icons/duotune/general/gen040.svg",
                                body: _ctx.review.desc_doc_type
                              }, null, 8, ["body"]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("small", null, _toDisplayString(_ctx.kyc?.doc_type !== null
                          ? _ctx.KYCDocTypes[_ctx.kyc.doc_type]
                          : "N/A"), 1)
                              ])
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1024),
                    _createVNode(_component_Accordion, { id: "official_doc" }, _createSlots({
                      header: _withCtx(() => [
                        _createVNode(_component_ReviewItemHeader, {
                          title: "Official Document Front",
                          status: _ctx.getStatusMessage(_ctx.review.official_doc),
                          passed: _ctx.review.official_doc
                        }, null, 8, ["status", "passed"])
                      ]),
                      _: 2
                    }, [
                      (_ctx.review.desc_official_doc && !_ctx.review.official_doc)
                        ? {
                            name: "hidden",
                            fn: _withCtx(() => [
                              _createVNode(_component_Notice, {
                                classes: "rounded-3 mb-8",
                                color: "danger",
                                title: "Decline Reason",
                                icon: "media/icons/duotune/general/gen040.svg",
                                body: _ctx.review.desc_official_doc
                              }, null, 8, ["body"])
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1024),
                    (_ctx.kyc.official_doc_back)
                      ? (_openBlock(), _createBlock(_component_Accordion, {
                          key: 0,
                          id: "official_doc_back"
                        }, _createSlots({
                          header: _withCtx(() => [
                            _createVNode(_component_ReviewItemHeader, {
                              title: "Official Document Back",
                              status: _ctx.getStatusMessage(_ctx.review.official_doc_back),
                              passed: _ctx.review.official_doc_back
                            }, null, 8, ["status", "passed"])
                          ]),
                          _: 2
                        }, [
                          (
                    _ctx.review.desc_official_doc_back &&
                    !_ctx.review.desc_official_doc_back
                  )
                            ? {
                                name: "hidden",
                                fn: _withCtx(() => [
                                  _createVNode(_component_Notice, {
                                    classes: "rounded-3 mb-8",
                                    color: "danger",
                                    title: "Decline Reason",
                                    icon: "media/icons/duotune/general/gen040.svg",
                                    body: _ctx.review.desc_official_doc_back
                                  }, null, 8, ["body"])
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1024))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Accordion, {
                      id: "live_photo",
                      "show-separator": !!_ctx.kyc.doc_metadata
                    }, _createSlots({
                      header: _withCtx(() => [
                        _createVNode(_component_ReviewItemHeader, {
                          title: "Selfie Image",
                          status: _ctx.getStatusMessage(_ctx.review.live_photo),
                          passed: _ctx.review.live_photo
                        }, null, 8, ["status", "passed"])
                      ]),
                      _: 2
                    }, [
                      (_ctx.review.desc_live_photo && !_ctx.review.live_photo)
                        ? {
                            name: "hidden",
                            fn: _withCtx(() => [
                              _createVNode(_component_Notice, {
                                classes: "rounded-3 mb-8",
                                color: "danger",
                                title: "Decline Reason",
                                icon: "media/icons/duotune/general/gen040.svg",
                                body: _ctx.review.desc_live_photo
                              }, null, 8, ["body"])
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["show-separator"]),
                    (_ctx.kyc.aml)
                      ? (_openBlock(), _createBlock(_component_Accordion, {
                          key: 1,
                          id: "aml"
                        }, {
                          header: _withCtx(() => [
                            _createVNode(_component_ReviewItemHeader, {
                              title: "AML Status",
                              status: _ctx.kyc.aml?.status_display,
                              passed: 
                      _ctx.kyc.aml?.status === _ctx.AMLVerificationStatus.FOUND ||
                      _ctx.kyc.aml?.status === _ctx.AMLVerificationStatus.PARTIALLY_FOUND
                    
                            }, null, 8, ["status", "passed"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_OCRModal, {
      meta: _ctx.meta,
      "is-admin": _ctx.currentUser?.user_type === 2
    }, null, 8, ["meta", "is-admin"])
  ], 64))
}